import { Component, OnInit, ViewChild, AfterViewInit, ViewChildren } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { AddassettypepopupComponent } from '../../generalpopup/addassettypepopup/addassettypepopup.component';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { HostListener } from '@angular/core';

@Component({
  selector: 'app-addasset',
  templateUrl: './addasset.component.html',
  styleUrls: ['./addasset.component.css']
})
export class AddassetComponent implements OnInit, AfterViewInit {

  @ViewChildren('input') firstipcontrol;

  @ViewChild('documentbar', { static: false }) documentbar;

  formname: string = "Asset";
  trxtype: string = "ASSET";
  rtnform: string = "";
  //Display
  formmode: string = "Add";

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;

  ismanualclose: boolean;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  //Edit Get Values
  assettypeColl: any = [];
  assetColl: any = [];
  assetBO: any = {};
  assetid: number = 0

  historyassetColl: any = [];

  assetform = new FormGroup({
    assetid: new FormControl(0),
    assetno: new FormControl('', Validators.required),
    assetname: new FormControl('', Validators.required),
    assettypeid: new FormControl(null, Validators.required),
    assetvalue: new FormControl(null),
    remarks: new FormControl(''),
    brandname: new FormControl(''),
    model: new FormControl(''),
    serialno: new FormControl(''),
    warrantydt: new FormControl(null, Validators.required),
    purchasedt: new FormControl(null, Validators.required),
    invoiceno: new FormControl(''),
    assetcurrentvalue: new FormControl(null),
    locationname: new FormControl(''),
    descr: new FormControl(''),
    supplier: new FormControl(''),
    inactive: new FormControl(false),
  });

  editformtype: string = "";

  dateCustomClasses: DatepickerDateCustomClasses[];

  constructor(private appService: AppdataService, private loginService: LoginserviceService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, private productFindService: NgbModal, private datePipe: DatePipe) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.assetid = params.id
      }
      if (params.rtnform !== undefined) {
        this.rtnform = params.rtnform
      }
    });

    this.fnServiceChanges();
    this.dateCustomClasses = [
      { date: new Date(), classes: ['bg-warning'] },
    ];
  }


  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }

    });
  }



  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.assetform.reset();
      this.fnInitializeFormGroup();

      if (this.assetid > 0) {
        this.fngetAsset();
      }
      this.fngetAssetType();
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.assetid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }
  ngAfterViewInit()
  {
    this.loginService.fnSetFirstControlFocus('txtfirst');
  }
  fnInitializeFormGroup() {
    this.assetform.setValue({
      assetid: 0,
      assetno: 'new',
      assetname: '',
      brandname: '',
      model: '',
      serialno: '',
      warrantydt: null,
      purchasedt: null,
      invoiceno: '',
      assetcurrentvalue: null,
      locationname: '',
      assettypeid: null,
      assetvalue: null,
      remarks: '',
      descr: '',
      supplier: '',
      inactive: false
    })
  }


  fngetAssetType() {

    var data = {
      'assettypeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getAssetType(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.assettypeColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //Get 
  fngetAsset() {
    if (this.showProgress) {
      return;
    }
    var data = {

      'assetid': this.assetid,
      'companyid': this.loginService.fnGetCompanyId()
    }
    this.appService.getAsset(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.fnHideProgress();

            var result = res.json().result;
            this.assetColl = result[0];
            var editdata = this.assetColl[0];
            this.fnEditMode(editdata);
            this.assetBO = editdata;

            this.historyassetColl = result[1];

            this.documentbar.trxtype = this.trxtype;
            this.documentbar.trxid = this.assetid;
            this.documentbar.formname = this.formname;
            this.documentbar.fnGetDocument();
          }
          else {
            this.fnHideProgress();

            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.fnHideProgress();

          this.toastr.error('Error', err);
        })
  }



  //Save Btn Click
  fnSaveBtnClick() {
    try {
    
      this.submitted = true;
      this.successfully = false;
      if (this.loginService.fnCheckFornControlNotfound(this.assetform.get('warrantydt'))) {
        this.assetform.controls['warrantydt'].setErrors(null);
      }

      //Validate
      if (this.assetform.valid) {

        if (this.loginService.fnCompareDateValidation(this.assetform.get('warrantydt').value, this.assetform.get('purchasedt').value)) {
          this.assetform.controls['warrantydt'].setErrors({ 'notfound': true });
          return
        }
        //Check
        this.saveloading = true;

        var data = {
          'assetid': this.assetid,
          'assetno': this.assetform.get('assetno').value,
          'assetname': this.assetform.get('assetname').value,
          'assettypeid': this.assetform.get('assettypeid').value,
          'brandname': this.assetform.get('brandname').value,
          'model': this.assetform.get('model').value,
          'serialno': this.assetform.get('serialno').value,
          'warrantydt': this.fnFormatDatetime(this.assetform.get('warrantydt').value),
          'purchasedt': this.fnFormatDatetime(this.assetform.get('purchasedt').value),
          'invoiceno': this.assetform.get('invoiceno').value,
          'assetcurrentvalue': this.assetform.get('assetcurrentvalue').value,
          'locationname': this.assetform.get('locationname').value,
          'assetvalue': this.assetform.get('assetvalue').value,
          'remarks': this.assetform.get('remarks').value,
          'descr': this.assetform.get('descr').value,
          'supplier': this.assetform.get('supplier').value,
          'inactive': this.assetform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }


        this.appService.fnCheckAsset(data).subscribe(
          (res) => {
            if (res.json().status === 200) {
              var _checkresult = res.json().result[0].checkfield;

              if (_checkresult === "done") {
                if (this.assetform.get('assetid').value > 0) {
                  //Update 
                  this.fnSetAsset(data);
                }
                else {
                  //Insert 
                  this.fnInsertAsset(data);
                }
              }
              else {
                if (_checkresult === "name") {
                  this.saveloading = false;

                  this.assetform.controls['assetno'].setErrors({ 'notfound': true });
                }
              }
            }
            else {
              this.saveloading = false;

              this.loginService.fnAPIError(res.json())
            }
          },
          (err) => {
            this.saveloading = false;

            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertAsset(data) {

    this.appService.fnInsertAsset(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.toastr.success('', "The new asset has been added successfully.Insert Successfully");
            this.fnInsertActivityLog('INSERT', 0, data.assetname);
            var _result = res.json().result;
            if (_result.length > 0) {
              this.fnEditFormEdit(_result[0].assetid);
            }
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetAsset(data) {

    this.appService.fnSetAsset(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.toastr.success('', "The asset has been updated successfully.");
            this.fnInsertActivityLog('EDIT', this.assetid, data.assetname);
            this.fnEditFormEdit(this.assetid);
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.saveloading = true;

        this.toastr.error('Error', err);
      });

  }

  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }

  //AddReimburseType
  private fnAddAssetType() {

    const modalRef = this.productFindService.open(AddassettypepopupComponent, { size: <any>'l' });

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fngetAssetType();

      if (receivedEntry > 0) {
        this.assetform.patchValue({ assettypeid: receivedEntry })
      }
    });

  }

  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }

  //Close
  async fnCloseForm() {
    try {
      if ((this.isaddmode || this.iseditmode) && !this.ismanualclose) {
        var a = await this.loginService.fnConfirmFormLeave();
        if (a === false) {
          return false;
        }
      }

      this.ismanualclose = true;

      if (this.rtnform !== '') {
        this.router.navigate(['/' + this.rtnform]);
      } else {
        let navigationExtras: NavigationExtras = {
          queryParams: {
           
          }
        }
        this.router.navigate(['/Asset'], navigationExtras);
       
      }


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnTabHeaderClick(type) {

    this.editformtype = type;

  }
  fnEditFormEdit(id) {

    this.assetid = id;
    this.isaddmode = false;
    this.iseditmode = false;
    this.isdeletemode = false;
    this.isviewmode = true;

    let navigationExtras: NavigationExtras = {
      queryParams: {
       'id':this.assetid,
      }
    }

    this.router.navigate(['/AddAsset'], navigationExtras).then(() => {
      window.location.reload();
    });

  }
  fnEditBtnClick() {
    this.iseditmode = true;

    this.isviewmode = false;
  }

  private fnEditMode(deptBO) {
    deptBO.warrantydt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.warrantydt));
    deptBO.purchasedt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.purchasedt));

    this.assetform.setValue({
      assetid: deptBO.assetid,
      assetno: deptBO.assetno,
      assetname: deptBO.assetname,
      brandname: deptBO.brandname,
      model: deptBO.model,
      serialno: deptBO.serialno,
      warrantydt: deptBO.warrantydt,
      purchasedt: deptBO.purchasedt,
      invoiceno: deptBO.invoiceno,
      assetcurrentvalue: deptBO.assetcurrentvalue,
      locationname: deptBO.locationname,
      assettypeid: deptBO.assettypeid,
      assetvalue: deptBO.assetvalue,
      remarks: deptBO.remarks,
      descr: deptBO.descr,
      supplier: deptBO.supplier,
      inactive: deptBO.inactive
    });

    this.formmode = "Edit";

    this.isaddmode = false;
    this.iseditmode = false;
    this.isdeletemode = false;
    this.isviewmode = true;
  }
  @HostListener('window:beforeunload')
  canDeactivate(): any {
    if (this.isaddmode || this.iseditmode) {
      return false;
    }
    else {
      return true;
    }
  }

  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }
  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }
  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }






}
